import { useState, useRef, useEffect } from "react";
import { Phone, MessageSquare } from "lucide-react";

export default function PhoneButton({ className, children, variant = "default" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        data-testid="phone-button"
        className={className}
      >
        {children}
      </button>

      {open && (
        <div
          data-testid="phone-dropdown"
          className="absolute top-full left-1/2 -translate-x-1/2 mt-2 z-50 min-w-[180px] glass-panel border border-white/10 overflow-hidden"
        >
          <a
            href="tel:0676806203"
            data-testid="phone-call-option"
            className="flex items-center gap-3 px-5 py-3 text-white/70 text-sm tracking-wider hover:bg-gold/10 hover:text-gold transition-all duration-300"
            onClick={() => setOpen(false)}
          >
            <Phone size={14} strokeWidth={1.2} />
            <span>Appeler</span>
          </a>
          <div className="h-px bg-white/5" />
          <a
            href="sms:0676806203"
            data-testid="phone-sms-option"
            className="flex items-center gap-3 px-5 py-3 text-white/70 text-sm tracking-wider hover:bg-gold/10 hover:text-gold transition-all duration-300"
            onClick={() => setOpen(false)}
          >
            <MessageSquare size={14} strokeWidth={1.2} />
            <span>Envoyer un SMS</span>
          </a>
        </div>
      )}
    </div>
  );
}
